<template lang="html">


    <div class="cover-popup-donacion row-center" v-if="!!project">
        <section class="popup-donacion">
            <div class="top row-center">
                <h2>Colabora</h2>
                <h3><strong>{{ project.per }}%</strong> Financiado</h3>
                <a class="close" @click="eraseProject">✕</a>
            </div>
            <div class="main column-center">
                <payment :id="project.id"></payment>
            </div>
        </section>
    </div>


</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex';

    import payment from '@/components/parts/payment'
  
    export default  {
      name: 'payment-popup',
      data(){
        return{
        }
      },
      computed : {
          ...mapGetters({
              project : 'getProject'
          }),
          percent(){
            if(this.project.complete === 1) {
              return 100;
            }
            //return (100 * this.project.total / this.project.money_needed).toFixed(2);
            return this.project.per;
          }
      },
      methods : {
        ...mapActions(['eraseProject'])
      },
      components : {
        'payment' : payment
      }
  }
  </script>


// WEBPACK FOOTER //
// src/components/parts/payment-popup.vue